import React, { useEffect } from 'react';
import { trackEvent } from './components/analytics/GoogleAnalytics';
import config from './config';

const SuccessPage = ({ setView }) => {
    useEffect(() => {
        trackEvent('purchase_complete', { currency: 'GBP' });
    }, []);

    return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6 relative overflow-hidden">
            {/* Background Glows */}
            <div className="absolute top-1/4 -left-20 w-96 h-96 bg-indigo-500/10 rounded-full blur-[120px] pointer-events-none" />
            <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-emerald-500/10 rounded-full blur-[120px] pointer-events-none" />
            
            <div className="max-w-2xl w-full relative">
                {/* Main Card */}
                <div className="bg-slate-900/40 backdrop-blur-3xl border border-white/10 rounded-[2.5rem] p-8 md:p-12 shadow-2xl text-center relative z-10">
                    <div className="mb-10 relative inline-block">
                        {/* Outer Glow Ring */}
                        <div className="absolute inset-0 bg-emerald-500/30 rounded-full blur-2xl animate-pulse" />
                        
                        {/* Success Icon Container */}
                        <div className="w-28 h-28 bg-emerald-500/20 rounded-full flex items-center justify-center relative border border-emerald-500/30">
                            <div className="w-20 h-20 bg-emerald-500 rounded-full flex items-center justify-center shadow-[0_0_40px_rgba(16,185,129,0.4)]">
                                <span className="text-4xl text-white drop-shadow-md">✓</span>
                            </div>
                        </div>
                    </div>
                    
                    <h1 className="text-4xl md:text-5xl font-black tracking-tight mb-4 text-white">
                        Access Granted!
                    </h1>
                    <p className="text-lg md:text-xl text-slate-400 max-w-lg mx-auto mb-10 leading-relaxed font-medium">
                        Welcome to <span className="text-white font-bold">Zap Premium</span>. Your faff-free expense journey starts here. 
                        Your subscription is now fully active.
                    </p>
                    
                    <div className="flex justify-center mb-12">
                        <button 
                            onClick={() => {
                                setView('home');
                                window.history.pushState({}, '', '/');
                            }}
                            className="bg-white text-slate-950 font-bold py-4 px-12 rounded-2xl hover:scale-[1.02] active:scale-[0.98] transition-all shadow-[0_10px_20px_rgba(255,255,255,0.1)] flex items-center justify-center gap-2 group"
                        >
                            <span>Return Home</span>
                            <span className="group-hover:translate-x-1 transition-transform">→</span>
                        </button>
                    </div>
                </div>
                
                {/* Footer Link */}
                <div className="mt-10 text-center relative z-10">
                    <p className="text-slate-500 text-sm">
                        Got questions? <a href={`mailto:${config.SUPPORT_EMAIL}`} className="text-indigo-400 hover:text-indigo-300 font-medium underline underline-offset-4">Drop us an email</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SuccessPage;
